import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import { fetchData, fetchFormData } from "../../utils/options";
import topTost from "../../utils/topTost";

const TaskStatusCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [taskStatus, setTaskStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);
  const fetchStatus = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id);
      const result = await fetchFormData(
        `task-status/getbyid`,
        formData,
        "POST"
      );

      if (result && result.data) {
        setTaskStatus(result.data.task_status_name);
      } else {
        console.warn("State data not found.");
        setTaskStatus("");
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      setTaskStatus("");
    }
  };

  useEffect(() => {
    if (id) {
      fetchStatus(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("task_status_name", taskStatus);
    formData.append("status", "1");
    formData.append("branchID", "1");
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    try {
      let response;

      if (id) {
        formData.append("id", id);
        formData.append("userId", userId);
        response = await fetchFormData("task-status/update", formData, "POST");
      } else {
        response = await fetchFormData("task-status/add", formData, "POST");
      }

      if ((response && response.code === 200) || 201 || "Status added") {
        navigate(`/task/task-status-list?id=${M_id}`);
        topTost({
          title: response.message,
          icon: "success",
        });
      } else if (response && response.message === "Status updated") {
        topTost({
          title: response.message,
          icon: "success",
        });
      } else {
        console.error(" operation failed", response);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Task Status:" : "Add Task Status:"}
                </span>
              </h5>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    icon="feather-briefcase"
                    label="Task Status"
                    labelId="taskStatusInput"
                    placeholder="Task Status"
                    name="task_status"
                    value={taskStatus}
                    required
                    onChange={(name, value) => setTaskStatus(value)}
                  />
                </div>
                <div className="col-md-6">
                  <button
                    type="submit"
                    className="btn btn-lg btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default TaskStatusCreate;
